import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function useKeyboardShortcuts(onCmdK) {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (e) => {
      const tag = document.activeElement?.tagName?.toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'select') return;

      const isMeta = e.metaKey || e.ctrlKey;

      if (isMeta && e.key === 'k') {
        e.preventDefault();
        if (onCmdK) onCmdK();
        return;
      }

      if (isMeta && e.key === 'j') {
        e.preventDefault();
        navigate('/agent', { state: { newChat: true } });
        return;
      }

      if (e.key === 'g' && !isMeta) {
        e.preventDefault();
        const handler = (e2) => {
          document.removeEventListener('keydown', handler);
          if (e2.key === 'd') navigate('/dashboard');
          if (e2.key === 'a') navigate('/agent', { state: { newChat: true } });
          if (e2.key === 's') navigate('/settings');
        };
        document.addEventListener('keydown', handler);
        setTimeout(() => document.removeEventListener('keydown', handler), 1000);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [navigate, onCmdK]);
}
